import { Component } from '@angular/core';

import { BaseListHeaderComponent } from './BaseListHeader.component';

@Component({
    selector: 'admin-list-header',
    templateUrl: 'ListHeader.component.html'
})
export class ListHeaderComponent<I> extends BaseListHeaderComponent<I> {}
